module.exports = __webpack_public_path__ + "images/Group 12572428029d64eea2b93b67a928fa7bbeac.svg";